import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { PrivyProvider } from '@privy-io/react-auth';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <PrivyProvider
      appId="clx1tly0r01hjycopq59f9xfq"
      config={{
        loginMethods: ['email', 'google', 'farcaster', 'wallet'],
        appearance: {
          theme: 'light',
          accentColor: '#744539',
        },
        embeddedWallets: {
          createOnLogin: 'users-without-wallets',
          noPromptOnSignature: true,
        },
      }}
    >
      <App />
    </PrivyProvider>
  </React.StrictMode>,
);
